import React from 'react';
import { Outlet } from 'react-router';



function WithoutNav(){

    return(
        <div className="WithoutNav">
        <Outlet/>
        </div>
    )


}

export default WithoutNav;